import { jsxs as h, jsx as s } from "react/jsx-runtime";
import { c as pe } from "react/compiler-runtime";
import { Box as m, Typography as re, TextField as ge, InputAdornment as he, List as me, ListItem as ie, Checkbox as xe, ListItemText as be } from "@mui/material";
import Ce from "@mui/icons-material/ViewWeek";
import ye from "@mui/icons-material/Search";
import De from "@mui/icons-material/DragIndicator";
import { useState as f, useRef as oe, useEffect as ne } from "react";
import { u as Se } from "../../../chunks/TableContext.js";
import { flexRender as Fe } from "@tanstack/react-table";
function Ke(j) {
  const e = pe(46), {
    searchBarHeight: u
  } = j, {
    table: n,
    hiddenColumns: x,
    groupByColumns: b,
    enableVirtualization: le,
    showColumnVisibilitySidebar: W
  } = Se();
  let C;
  e[0] !== x ? (C = x === void 0 ? [] : x, e[0] = x, e[1] = C) : C = e[1];
  const a = C, [o, Q] = f(!1), [p, se] = f("");
  let y;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = {}, e[2] = y) : y = e[2];
  const [$, X] = f(y), [N, H] = f(null), [D, S] = f(null);
  let F;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (F = [], e[3] = F) : F = e[3];
  const [c, Z] = f(F), _ = oe(!1), P = oe(null);
  let k;
  e[4] !== o ? (k = () => {
    Q(!o);
  }, e[4] = o, e[5] = k) : k = e[5];
  const U = k;
  let v;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = (t) => {
    se(t.target.value);
  }, e[6] = v) : v = e[6];
  const ae = v;
  let w;
  e[7] !== n ? (w = (t) => {
    X((r) => ({
      ...r,
      [t]: !r[t]
    })), n.getColumn(t)?.toggleVisibility();
  }, e[7] = n, e[8] = w) : w = e[8];
  const Y = w;
  let I;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (I = (t, r) => {
    H(r), t.dataTransfer.effectAllowed = "move", t.dataTransfer.setData("text/plain", r);
  }, e[9] = I) : I = e[9];
  const de = I;
  let E;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (E = (t, r) => {
    t.preventDefault(), t.dataTransfer.dropEffect = "move", S(r);
  }, e[10] = E) : E = e[10];
  const ce = E;
  let O;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (O = () => {
    S(null);
  }, e[11] = O) : O = e[11];
  const fe = O;
  let R;
  e[12] !== c || e[13] !== n ? (R = (t, r) => {
    t.preventDefault();
    const i = t.dataTransfer.getData("text/plain");
    if (i && i !== r) {
      const l = [...c], ee = l.indexOf(i), te = l.indexOf(r);
      ee !== -1 && te !== -1 && (l.splice(ee, 1), l.splice(te, 0, i), Z(l), n.setColumnOrder(l));
    }
    H(null), S(null);
  }, e[12] = c, e[13] = n, e[14] = R) : R = e[14];
  const q = R;
  let T;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = () => {
    H(null), S(null);
  }, e[15] = T) : T = e[15];
  const ue = T;
  let B;
  e[16] !== n ? (B = n.getAllColumns(), e[16] = n, e[17] = B) : B = e[17];
  const d = B;
  let g;
  if (e[18] !== d || e[19] !== c || e[20] !== a) {
    e: {
      let t;
      e[22] !== a ? (t = (i) => !a.includes(i.id), e[22] = a, e[23] = t) : t = e[23];
      const r = d.filter(t);
      if (c.length > 0) {
        g = c.map((i) => r.find((l) => l.id === i)).filter(we);
        break e;
      }
      g = r;
    }
    e[18] = d, e[19] = c, e[20] = a, e[21] = g;
  } else
    g = e[21];
  const z = g;
  let A, L;
  e[24] !== d || e[25] !== a ? (A = () => {
    if (!_.current && d.length > 0) {
      const t = d.filter((r) => !a.includes(r.id));
      if (t.length > 0) {
        const r = {}, i = [];
        t.forEach((l) => {
          r[l.id] = l.getIsVisible(), i.push(l.id);
        }), X(r), Z(i), _.current = !0;
      }
    }
  }, L = [d, a], e[24] = d, e[25] = a, e[26] = A, e[27] = L) : (A = e[26], L = e[27]), ne(A, L);
  let G;
  e: {
    if (le) {
      G = `calc(100% - ${u + 12}px)`;
      break e;
    }
    G = `calc(100% - ${u + 61}px)`;
  }
  const J = G;
  let K, V;
  e[28] !== o ? (K = () => {
    const t = (r) => {
      o && P.current && !P.current.contains(r.target) && Q(!1);
    };
    return o && document.addEventListener("mousedown", t), () => {
      document.removeEventListener("mousedown", t);
    };
  }, V = [o], e[28] = o, e[29] = K, e[30] = V) : (K = e[29], V = e[30]), ne(K, V);
  let M;
  return e[31] !== J || e[32] !== $ || e[33] !== D || e[34] !== N || e[35] !== b || e[36] !== Y || e[37] !== q || e[38] !== U || e[39] !== o || e[40] !== u || e[41] !== p || e[42] !== W || e[43] !== n || e[44] !== z ? (M = W ? /* @__PURE__ */ h(m, { ref: P, sx: {
    zIndex: 1e3,
    height: J,
    width: "24px",
    position: "absolute",
    right: "1px",
    borderLeft: "1px solid #EFEFEF",
    backgroundColor: "white",
    marginTop: `${u + 11}px`,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "8px",
    borderTopRightRadius: "8px",
    borderBottomRightRadius: "8px"
  }, children: [
    /* @__PURE__ */ h(m, { onClick: U, sx: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "8px",
      cursor: "pointer",
      padding: "24px 0px",
      width: "100%",
      backgroundColor: o ? "#F3F4F6" : "transparent",
      "&:hover": {
        backgroundColor: o ? "#E5E7EB" : "#F9FAFB"
      },
      borderTopRightRadius: "7px"
    }, children: [
      /* @__PURE__ */ s(Ce, { sx: {
        fontSize: "12px",
        color: o ? "primary.main" : "#6B7280"
      } }),
      /* @__PURE__ */ s(re, { sx: {
        writingMode: "vertical-lr",
        textOrientation: "mixed",
        borderRadius: "2px",
        color: o ? "primary.main" : "#6B7280",
        fontSize: "14px",
        fontWeight: o ? 500 : 400
      }, children: "Columns" })
    ] }),
    o && /* @__PURE__ */ h(m, { sx: {
      position: "absolute",
      right: "24px",
      top: "0",
      height: "100%",
      width: "240px",
      backgroundColor: "white",
      zIndex: 1001,
      borderLeft: "1px solid #EFEFEF",
      display: "flex",
      flexDirection: "column"
    }, children: [
      /* @__PURE__ */ s(m, { sx: {
        padding: "8px"
      }, children: /* @__PURE__ */ s(ge, { fullWidth: !0, size: "small", placeholder: "Search...", value: p, onChange: ae, InputProps: {
        startAdornment: /* @__PURE__ */ s(he, { position: "start", sx: {
          marginRight: "0px"
        }, children: /* @__PURE__ */ s(ye, { sx: {
          fontSize: "18px",
          color: "#6B7280"
        } }) })
      }, sx: {
        "& .MuiOutlinedInput-root": {
          fontSize: "14px",
          borderRadius: "6px"
        },
        "& .MuiInputBase-input": {
          padding: "6px 10px",
          fontSize: "14px"
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#9CA3AF",
          opacity: 1
        }
      } }) }),
      /* @__PURE__ */ s(m, { sx: {
        flex: 1,
        overflow: "hidden"
      }, children: /* @__PURE__ */ h(me, { sx: {
        padding: 0,
        height: "100%",
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          width: "6px"
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#F3F4F6"
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#D1D5DB",
          borderRadius: "3px"
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#9CA3AF"
        }
      }, children: [
        z.filter((t) => {
          const r = t.columnDef;
          let i;
          return r.header ? typeof r.header == "string" ? i = r.header : (r.header, i = r.accessorKey ? String(r.accessorKey) : t.id) : i = r.accessorKey ? String(r.accessorKey) : t.id, i.toLowerCase().includes(p.toLowerCase());
        }).map((t) => {
          if (console.log(t.columnDef, b), t.columnDef.id === "expander" || b.includes(t.id))
            return null;
          const r = Fe(t.columnDef.header, {
            column: t,
            table: n,
            header: {
              column: t
            },
            row: null,
            cell: null,
            getValue: ve,
            renderValue: ke
          });
          return /* @__PURE__ */ h(ie, { draggable: !0, onDragStart: (i) => de(i, t.id), onDragOver: (i) => ce(i, t.id), onDragLeave: fe, onDrop: (i) => q(i, t.id), onDragEnd: ue, sx: {
            padding: "8px 16px",
            borderBottom: "1px solid #F3F4F6",
            opacity: N === t.id ? 0.5 : 1,
            backgroundColor: D === t.id ? "#E3F2FD" : "transparent",
            "&:last-child": {
              borderBottom: "none"
            },
            "&:hover": {
              backgroundColor: D === t.id ? "#E3F2FD" : "#F9FAFB"
            }
          }, children: [
            /* @__PURE__ */ s(xe, { checked: $[t.id] ?? !0, onChange: () => Y(t.id), size: "small", sx: {
              padding: "4px",
              marginRight: "8px",
              "&.Mui-checked": {
                color: "primary.main"
              }
            } }),
            /* @__PURE__ */ s(De, { sx: {
              fontSize: "16px",
              color: "#9CA3AF",
              cursor: "grab",
              "&:active": {
                cursor: "grabbing"
              },
              marginRight: "12px"
            } }),
            /* @__PURE__ */ s(be, { primary: r || "Unnamed Column", sx: {
              flex: 1,
              "& .MuiListItemText-primary": {
                fontSize: "14px",
                color: "#374151",
                fontWeight: 400
              }
            } })
          ] }, t.id);
        }),
        z.filter((t) => {
          const r = t.columnDef;
          let i;
          return r.header ? typeof r.header == "string" ? i = r.header : (r.header, i = r.accessorKey ? String(r.accessorKey) : t.id) : i = r.accessorKey ? String(r.accessorKey) : t.id, i.toLowerCase().includes(p.toLowerCase());
        }).length === 0 && /* @__PURE__ */ s(ie, { sx: {
          padding: "16px",
          justifyContent: "center"
        }, children: /* @__PURE__ */ s(re, { sx: {
          color: "#9CA3AF",
          fontSize: "14px"
        }, children: "No items found" }) })
      ] }) })
    ] })
  ] }) : null, e[31] = J, e[32] = $, e[33] = D, e[34] = N, e[35] = b, e[36] = Y, e[37] = q, e[38] = U, e[39] = o, e[40] = u, e[41] = p, e[42] = W, e[43] = n, e[44] = z, e[45] = M) : M = e[45], M;
}
function ke() {
  return null;
}
function ve() {
  return null;
}
function we(j) {
  return j !== void 0;
}
export {
  Ke as ColumnVisibilityToggle
};
